import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconScript2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconScript2"><Path d="M7.5 20.5H4.5C3.39543 20.5 2.5 19.6046 2.5 18.5V16.5H14.5V19C14.5 19.8284 15.1716 20.5 16 20.5C16.8284 20.5 17.4999 19.8284 17.4999 19V5.25C17.4999 4.2835 18.2834 3.5 19.2499 3.5C20.2164 3.5 20.9999 4.2835 20.9999 5.25V9.5H17.4999" stroke="currentColor"/><Path d="M19 3.5H7.5C6.39543 3.5 5.5 4.39543 5.5 5.5V16.5" stroke="currentColor"/><Path d="M16 20.5H6" stroke="currentColor"/></CentralIconBase>;
});

export default IconScript2;
